module.exports = __webpack_public_path__ + "img/icon_shezhi.fc7030b3.svg";